var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookingUser = function SvgBookingUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#867659",
    d: "M15.602 7.2a3.6 3.6 0 1 0-7.201 0 3.6 3.6 0 0 0 7.2 0m-8.4 0a4.8 4.8 0 1 1 9.6 0 4.8 4.8 0 0 1-9.6 0M5.225 20.4h13.55L17.116 15H6.887zm.777-6.6h12l2.032 6.6.368 1.2h-16.8l.367-1.2z"
  })));
};
export default SvgBookingUser;